var map = {
	"./calendar-icon.svg": "3c84",
	"./icon-corona-menu-covid.svg": "f517",
	"./icon-historical-menu-covid.svg": "53cc",
	"./icon-lock-menu-covid.svg": "0346",
	"./icon-medical-mask-menu-covid.svg": "e18c",
	"./icon-prevention-menu-covid.svg": "1be0",
	"./icon-prognostic-menu-covid.svg": "7100",
	"./icon-quiz-menu-covid.svg": "e651",
	"./icon-screening-menu-covid.svg": "d127",
	"./icon-shield-menu-covid.svg": "5714",
	"./icon-tests-menu-covid.svg": "730d",
	"./icon-vaccine-menu-covid.svg": "6225"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e0f1";